<template>
  <div>
    <table v-if="isScoreHistoryTableVisible" class="score-table table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">№</th>
          <th scope="col">
            Время<br>
            после<br>
            присоединения<br>
            к заезду
          </th>
          <th scope="col">Очки</th>
        </tr>
      </thead>
      <tr
        v-for="(record, index) in scoreHistory"
        :key="index"
      >
        <td class="text-right">
          {{index + 1 | getFormattedNumber}}
        </td>
        <td>
          {{record.ctime | convertDurationSecToShortStr}}
        </td>
        <td class="text-right">
          {{record.score | getFormattedNumber}}
        </td>
      </tr>
      <tr v-if="isScoreSumVisible">
        <td colspan="3" class="text-right pt-4">
          Сумма: {{scoreSum | getFormattedNumber}}
        </td>
      </tr>
    </table>

    <loading-indicator v-if="isLoading"/>

    <p v-if="message !== null">
      {{message}}
    </p>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { convertDurationSecToShortStr } from '../util.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'RushRacePlayerScoreHistory',

  components: {
    LoadingIndicator,
  },

  props: {
    rushRaceId: {
      type: Object,
      required: true
    },

    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      scoreHistory: null,
    };
  },

  computed: {
    rushId() {
      return this.rushRaceId.rushId;
    },

    raceId() {
      return this.rushRaceId.raceId;
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const NO_ITEMS_TEXT = 'Игрок не получал очков.';
      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return NO_ITEMS_TEXT;
      }
      if(scoreHistory.length === 0) {
        return NO_ITEMS_TEXT;
      }

      return null;
    },

    /** @returns {boolean} */
    isScoreHistoryTableVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return false;
      }

      return scoreHistory.length > 0;
    },

    /** @returns {boolean} */
    isScoreSumVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return false;
      }

      return scoreHistory.length > 1;
    },

    /** @returns {?number} */
    scoreSum() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return 0;
      }

      let sum = 0;
      for(const item of scoreHistory) {
        sum += item.score;
      }

      return sum;
    },
  },

  created() {
    this.loadScoreHistory();
  },

  methods: {
    loadScoreHistory() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const rushId = this.rushId;
      const raceId = this.raceId;
      const playerId = this.playerId;
      const url = `/rush/${rushId}/race/${raceId}/player/${playerId}/score_history`;

      HTTP.get(url)
      .then(response => {
        this.scoreHistory = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

  filters: {
    convertDurationSecToShortStr,
  },
};
</script>

<style scoped>
.score-table {
  max-width: 1px;
}
</style>
